import { useState } from 'react';
import { useParams } from 'react-router';

import RecreateFilters from './filters/RecreateFilters';
import RecreateOutput from './output/RecreateOutput';
import UploadModal from './upload-modal/UploadModal';
import ImagesGeneratingStatusController from '../generating-status-controller/ImagesGeneratingStatusController';
import { PROMPT_TYPE } from '../../../constants';
import { useProject } from '../../../context/ProjectContext';

import scss from '../../Id8.module.scss';

function RecreateTab() {
  const { actions } = useProject();
  const { id } = useParams();

  const [isShowUploadModal, setIsShowUploadModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleShowUploadModal = (files) => {
    const image = files[0];
    setUploadedImage(image);
    setIsShowUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setIsShowUploadModal(false);
    setUploadedImage(null);
  };

  const handleRecreate = (values) => {
    actions('recreateAd', { ...values, projectId: id });
  };

  return (
    <div className={scss.outputWrapper}>
      <RecreateFilters onShowUploadModal={handleShowUploadModal} />

      <RecreateOutput onShowUploadModal={handleShowUploadModal} />

      <UploadModal
        isOpen={isShowUploadModal}
        onClose={handleCloseUploadModal}
        uploadedImage={uploadedImage}
        onChangeImage={setUploadedImage}
        onSubmit={handleRecreate}
      />

      <ImagesGeneratingStatusController promptType={PROMPT_TYPE.RECREATE} generationLabel='recreateImagesInProgress' />
    </div>
  );
}

export default RecreateTab;
